/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Sample } from './Sample';
import {
    SampleFromJSON,
    SampleFromJSONTyped,
    SampleToJSON,
    SampleToJSONTyped,
} from './Sample';

/**
 * 
 * @export
 * @interface BranchesNetSalesTimeseriesResponse
 */
export interface BranchesNetSalesTimeseriesResponse {
    /**
     * 
     * @type {Array<Sample>}
     * @memberof BranchesNetSalesTimeseriesResponse
     */
    data: Array<Sample>;
}

/**
 * Check if a given object implements the BranchesNetSalesTimeseriesResponse interface.
 */
export function instanceOfBranchesNetSalesTimeseriesResponse(value: object): value is BranchesNetSalesTimeseriesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BranchesNetSalesTimeseriesResponseFromJSON(json: any): BranchesNetSalesTimeseriesResponse {
    return BranchesNetSalesTimeseriesResponseFromJSONTyped(json, false);
}

export function BranchesNetSalesTimeseriesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BranchesNetSalesTimeseriesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(SampleFromJSON)),
    };
}

export function BranchesNetSalesTimeseriesResponseToJSON(json: any): BranchesNetSalesTimeseriesResponse {
    return BranchesNetSalesTimeseriesResponseToJSONTyped(json, false);
}

export function BranchesNetSalesTimeseriesResponseToJSONTyped(value?: BranchesNetSalesTimeseriesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(SampleToJSON)),
    };
}

